import { LOCALE } from "../../../properties/Locale";
import * as yup from "yup";

export const validateGradingSchemaCreateForm = yup.object().shape({
  name: yup
    .string()
    .required(LOCALE.grading_schema_name + LOCALE.required_field),
});
